/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright (c) 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from "react";
import TabButtons from "./TabButtons.js";
import styles from "./tabs.module.scss";
import PropTypes from "prop-types";
import { generateId } from "./../_util/common.js";

class Tabs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab:  this.select_active_tab()
    };

  }
  select_active_tab = () => {
    if(this.props.children && this.props.children.length !== undefined ){
      if(this.props.children[0] === false){
          for(var i = 1; i <= this.props.children.length - 1; i++ ){
              if(this.props.children[i] !== false){
                return this.props.children[i].props.label
              }
          }
        }else{
          return this.props.children[0].props.label
        }
      }else{
      if(this.props.children === false){
          return 0;
      }else{
          return this.props.children.props.label
      }
    }
  }
  changeTab = (tab) => {
    this.setState({  activeTab: tab });
  };

  changeTabIndex = (count) => {
    this.setState({ activeTab: count })
  }
  componentDidMount() {
    React.Children.map(this.props.children, (child, index) => {
      if( child !== null && this.props.children[index] !== false){
        if (child.props.selected) {
            this.setState({ activeTab: this.props.children[index].props.label });
        }
    }
    });
    const tabComponentInstance = {
      changeTabIndex: this.changeTabIndex,
    };
    if(this.props.OnUpdateTab){
      this.props.OnUpdateTab(tabComponentInstance);
    } 
   }

   componentDidUpdate(prevProps) {
    if (prevProps?.children !== this.props?.children && !this.props.isEnableActiveTabs) {
      this.setState({ activeTab: this.select_active_tab() })
    } 

    if (prevProps?.children[0]?.props?.label !== this.props?.children[0]?.props?.label && this.props?.selectDefaultTab) {
      this.setState({ activeTab: this.select_active_tab() })
    } 
  }

  render() {
    let content;
    let buttons = [];
    return (
      <div className={styles.tab_container}>
        <div>
          { this.props.children && React.Children.map(this.props.children, (child) => {
            if(child !== null){
            buttons.push(child.props.label);
            if (child.props.label === this.state.activeTab)
              content = child.props.children;
            }
          })}
          <TabButtons
            id={this.props.id}
            activeTab={this.state.activeTab}
            buttons={buttons}
            changeTab={this.changeTab}
            tabBackground={this.props.tabBackground}
            navigationArrows={this.props.navigationArrows}
            scrollToTop={this.props.scrollToTop}
          />
        </div>
        <div>{content}</div>
      </div>
    );
  }
}

Tabs.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  id: PropTypes.string,
  tabBackground: PropTypes.string,
  navigationArrows: PropTypes.bool,
  initTab: PropTypes.number,
  OnUpdateTab: PropTypes.func,
  scrollToTop: PropTypes.bool,
  isEnableActiveTabs: PropTypes.bool,
  selectDefaultTab: PropTypes.bool
};

Tabs.defaultProps = {
  id: generateId(),
  selected: false,
  tabBackground: "#ffffff",
  navigationArrows:true,
  scrollToTop: true,
  isEnableActiveTabs: true,
  selectDefaultTab: false
};

export default Tabs;
